<template>
	<div v-show="show">
		<div class="login">
			<div class="bg_width"></div>
			<img :src="loginImg" alt="" class="login-left" />
			<div class="login-box login-box1">
				<div class="login-box1-title">{{ $t('MAIN_WEB_WELCOME_TO_LOGIN', { text: '欢迎登录' }) }}！</div>
				<div class="login-box1-tip" v-if="identityList && identityList.length">
					{{ $t('MAIN_WEB_YOUR_ACCOUNT_HAS_MULTIPLE_IDENTITIES_PLEASE_SELECT', { text: '您的账号拥有多个身份，请选择要登录的身份' }) }}
				</div>

				<ul class="login-box1-list" v-if="identityList && identityList.length">
					<li v-for="(item, index) in identityList" :key="index" @click="setUseridentity(item)">
						{{ item.name }}
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'identity',
	data() {
		return {
			identityList: [],
			show: false,
			loginImg: '',
			defaultImg: require('../../assets/images/pexels.png'),
		}
	},
	mounted() {
		this.loginImg = localStorage.getItem('loginImg') || this.defaultImg
		this.findMyIdentity()
	},
	methods: {
		findMyIdentity() {
			this.$api.userIdentityX_new.findMyIdentity().then((res) => {
				if (res.success && res.data && res.data.length) {
					if (res.data.length === 1) {
						this.setUseridentity(res.data[0])
					} else {
						this.show = true
					}
					this.identityList = res.data
				} else {
					this.$message.error(res.message)
				}
			})
		},

		async setUseridentity(item) {
			this.$api.account_new.switchIdentity({ identity: item.identity }).then((res) => {
				if (res.success) {
					localStorage.setItem('identityName', item.name)
					localStorage.setItem('identity', item.identity)
					this.$emit('changeShowidentity', false)
					this.$router.replace('/')
				}
			})
		},
	},
}
</script>

<style lang="stylus" scoped>
@import './css/index.styl';
</style>
